import { get, post } from "../../../api/axios-client";
import { Company, Database, UserLogin } from "../models/authTypes";

const controllerUrl = import.meta.env.VITE_AUTHENTICATION_API;

export const AuthenticationAPI = {
  getCompany: async (searchString: string): Promise<Company[] | null> => {
    const { data } = await get(
      `${controllerUrl}Companies/GetCompanyByCompanyName?name=${searchString}`
    );
    return data;
  },
  getCompanyById: async (companyId: string): Promise<Company | null> => {
    try {
      const { data } = await get(
        `${controllerUrl}Companies/GetCompanyById?companyIdentity=${companyId}`
      );
      return data;
    } catch (error) {
      console.warn("Failed to fetch company by ID:", error);
      return null;
    }
  },
  getDbsByCompany: async (
    companyIdentity: string
  ): Promise<Database[] | null> => {
    const url = `${controllerUrl}Databases?companyIdentity=${companyIdentity}`;
    const { data } = await get(url);
    return data;
  },

  authenticateUser: async (authRequest: UserLogin): Promise<any> => {
    try {
      const url = `${controllerUrl}AspenQueueAppAuthentication`;
      const { data } = await post(url, authRequest);
      return { success: true, data: data };
    } catch (error: any) {
      if (error?.response?.status === 402) {
        return { success: false, error: "402" };
      }
      const detail =
        error?.response?.data?.error ??
        error?.response?.data ??
        error?.message ??
        "An unexpected error occurred.";
      return {
        success: false,
        error: String(detail),
        status: error?.response?.status,
        url: error?.config?.url,
      };
    }
  },
};

export default AuthenticationAPI;
